module.exports = __webpack_public_path__ + "static/media/SVID_S_5.74ee82dc.png";